import request from '../request'


const path='/user-api/'
const pathInitMenu1='login'
const pathInitMenu2='register'
const pathInitMenu3='getVerifyCode'
const pathInitMenu4='getImgYzm'
const pathInitMenu5='forgetPassword'
const pathInitMenu6='getDicInfo'

// 登录
export const login =function (data) {
    return request.post(`${path}${pathInitMenu1}`,{
        ...data
        // yzm:yzm,
        // key:key,
        // phone:phone,
        // userPwd:userPwd,
    })
}

// 注册
// code,userName,idCard,phone,userPwd
export const register =function (data) {
    return request.post(`${path}${pathInitMenu2}`,{
       ...data
    })
}

// 获取手机验证码
export const getVerifyCode =function (phone) {
    return request.post(`${path}${pathInitMenu3}`,{
        phone:phone
    })
}

// 获取图片验证码
export const getImgYzm =function () {
    return request.post(`${path}${pathInitMenu4}`,{
       
    })
}

// 忘记密码
export const forgetPassword =function (data) {
    return request.post(`${path}${pathInitMenu5}`,{
       ...data
    })
}

// 获取字典信息
export const getDicInfo =function (data) {
    return request.post(`${path}${pathInitMenu6}`,{
        aaa100:data
    })
}